import { Box, Stack, TextField, Typography } from '@mui/material';

type MultilineFieldProps = {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  rows?: number;
};

export default function EntryComplement({ label, value, onChange, disabled = false, rows = 3 }: MultilineFieldProps) {
  return (
    <Box>
      <Typography variant="fieldHeader">{label}</Typography>
      <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
        <TextField
          sx={{
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              '& fieldset': {
                border: 'none',
              },
            },
          }}
          size="small"
          multiline
          rows={rows}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={disabled}
        />
      </Stack>
    </Box>
  );
}
